<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      show: false,
      periodKey: null
    };
  },

  computed: {
    ...mapState("newPurchase", ["start_at", "end_at"]),
    ...mapGetters("newPurchase", [
      "maxEndAt",
      "textPeriod",
      "enabledHours",
      "periods"
    ])
  },

  methods: {
    ...mapActions("newPurchase", ["setStartAt", "setEndAt"]),
    verifyStatus(hour) {
      if (hour === this.start_at) return "active";

      if (hour > this.maxEndAt) return "inactive";

      if (this.end_at && hour > this.start_at && hour <= this.end_at)
        return "active";

      if (
        this.periodKey != null &&
        !this.periods[this.periodKey].includes(hour)
      )
        return "inactive";

      var here = false;

      this.periods.forEach(element => {
        if (element.includes(hour)) here = true;
      });

      if (!here) return "inactive";
    },
    clicked(val) {
      if (this.verifyStatus(val) != "inactive") {
        if (!this.start_at || this.start_at > val) {
          this.setStartAt(val);

          this.periods.forEach((element, key) => {
            if (element.includes(val)) this.periodKey = key;
          });
        } else if (this.start_at === val) {
          this.setStartAt(null);
          this.setEndAt(null);
          this.periodKey = null;
        } else {
          this.setEndAt(val);
          this.show = false;
        }
      }
    }
  }
};
</script>

<template>
  <div class="general">
    <div class="period" @click="show = !show">{{textPeriod}}</div>

    <transition name="fade" mode="out-in">
      <div class="select" v-show="show">
        <ul>
          <li @click="clicked('07:00:00')" :class="verifyStatus('07:00:00')">07:00</li>
          <li @click="clicked('08:00:00')" :class="verifyStatus('08:00:00')">08:00</li>
          <li @click="clicked('09:00:00')" :class="verifyStatus('09:00:00')">09:00</li>
          <li @click="clicked('10:00:00')" :class="verifyStatus('10:00:00')">10:00</li>
          <li @click="clicked('11:00:00')" :class="verifyStatus('11:00:00')">11:00</li>
          <li @click="clicked('12:00:00')" :class="verifyStatus('12:00:00')">12:00</li>
          <li @click="clicked('13:00:00')" :class="verifyStatus('13:00:00')">13:00</li>
          <li @click="clicked('14:00:00')" :class="verifyStatus('14:00:00')">14:00</li>
          <li @click="clicked('15:00:00')" :class="verifyStatus('15:00:00')">15:00</li>
          <li @click="clicked('16:00:00')" :class="verifyStatus('16:00:00')">16:00</li>
          <li @click="clicked('17:00:00')" :class="verifyStatus('17:00:00')">17:00</li>
          <li @click="clicked('18:00:00')" :class="verifyStatus('18:00:00')">18:00</li>
          <li @click="clicked('19:00:00')" :class="verifyStatus('19:00:00')">19:00</li>
          <li @click="clicked('20:00:00')" :class="verifyStatus('20:00:00')">20:00</li>
          <li @click="clicked('21:00:00')" :class="verifyStatus('21:00:00')">21:00</li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.general {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.period {
  padding: 10px 20px 10px 50px;
  background-position: 15px center;
  background-size: 20px;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
  user-select: none;
}

.select {
  background: #fff;
  display: flex;
  justify-content: center;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  position: relative;
  width: 220px;
}

.select div {
  display: flex;
  flex-direction: row;
}

.select .buttons {
  justify-content: flex-end;
}

ul {
  flex: 1;
  padding: 0;
  list-style: none;
  width: 50%;
}

ul li {
  width: 100%;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  user-select: none;
}

ul li:hover {
  background-color: #eee;
}

ul li.active {
  color: #fff;
  background-color: var(--pink);
}

ul li.inactive {
  color: #ddd;
  cursor: auto;
}

ul li.title {
  cursor: auto;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 15px;
}

ul li.inactive:hover,
ul li.title:hover {
  background: transparent;
}

.period {
  background-image: url("../../../../static/icon-time.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/Period.vue